export default __webpack_public_path__ + "static/media/Sorcerer's Belt of Sovereign Rule.5db973c4.jpg";